<template>
    <b-container class="checkout_wrapper">
        <b-row>
            <b-col>
                <b-card>
                    <h2>Order Summary</h2>
                    <table v-if="project != null" class="table">
                        <thead>
                            <tr>
                                <th width="45%">Name</th>
                                <th>Prompts</th>
                                <th>Words</th>
                                <th>Session Fee</th>
                                <th>Overage Fee</th>
                                <th width="100" class="text-right">Subtotal</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{project.name}}</td>
                                <td class="text-center">{{project.prompts.length}}</td>
                                <td class="text-center">{{project.word_count}}</td>
                                <td class="text-center">${{project.record_fee}}</td>
                                <td class="text-center">${{extra_words_fee}}</td>
                                <td class="text-right">${{subtotal}}</td>
                            </tr>
                            <tr class="coupon-row" v-if="coupon.code">
                                <td colspan="5" class="text-right">
                                    Code: {{coupon.code}}
                                </td>
                                <td class="text-right">
                                    - ${{coupon.amount}}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="6" class="bottom-line">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td align="right">
                                                    <b-form @submit.prevent="applyCoupon">
                                                        <b-input-group size="sm" prepend="Coupon Code" class="coupon">
                                                            <b-form-input v-model="couponCode" type="text" :state="(typeof errors['coupon_code'] !== 'undefined') ? false : null" aria-describedby="input-live-feedback"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button type="submit" class="green">Apply</b-button>
                                                            </b-input-group-append>

                                                            <b-form-invalid-feedback id="input-live-feedback">
                                                                {{errors['coupon_code']}}
                                                            </b-form-invalid-feedback>
                                                        </b-input-group>
                                                    </b-form>
                                                </td>
                                                <td width="70" class="text-right"><strong>Total:</strong></td>
                                                <td width="100" class="total text-right">${{total_amount}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>
            </b-col>
        </b-row>
        
        <b-row>
            <b-col md="8">
                <b-card>
                    <h2>Billing Details</h2>
                    <b-row>
                        <b-col md="6">
                            <b-form-group label="First Name">
                                <b-input type="text" v-model="billing.first_name" :state="errors['billing.first_name'] ? false : null" aria-describedby="input-live-feedback" />
                                <b-form-invalid-feedback id="input-live-feedback">
                                    {{errors['billing.first_name']}}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group label="Last Name">
                                <b-input type="text" v-model="billing.last_name" :state="errors['billing.last_name'] ? false : null" aria-describedby="input-live-feedback" />
                                <b-form-invalid-feedback id="input-live-feedback">
                                    {{errors['billing.last_name']}}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <b-form-group label="Street 1">
                                <b-input type="text" v-model="billing.street_1" :state="errors['billing.street_1'] ? false : null" aria-describedby="input-live-feedback" />
                                <b-form-invalid-feedback id="input-live-feedback">
                                    {{errors['billing.street_1']}}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <b-form-group label="Street 2">
                                <b-input type="text" v-model="billing.street_2" />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="7">
                            <b-form-group label="City">
                                <b-input type="text" v-model="billing.city" :state="errors['billing.city'] ? false : null" aria-describedby="input-live-feedback" />
                                <b-form-invalid-feedback id="input-live-feedback">
                                    {{errors['billing.city']}}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group label="State">
                                <state-select v-model="billing.state" />
                            </b-form-group>
                        </b-col>
                        <b-col md="2">
                            <b-form-group label="Zip Code">
                                <b-input type="text" v-model="billing.postal_code" :state="errors['billing.postal_code'] ? false : null" aria-describedby="input-live-feedback" />
                                <b-form-invalid-feedback id="input-live-feedback">
                                    {{errors['billing.postal_code']}}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="8">
                            <b-form-group label="Country">
                                <country-select v-model="billing.country" />
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Phone">
                                <b-input type="text" v-model="billing.phone" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col md="4">
                <b-card>
                    <h2>Credit Card Info</h2>
                    <b-form @submit.prevent="submitOrder">
                        <b-alert show variant="danger" v-if="errors['credit_card']" v-html="errors['credit_card']"></b-alert>
                        <b-row>
                            <b-col>
                                <b-form-group label="Cardholder Name">
                                    <b-input type="text" :value="ccName" @change="updateCCName" />
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Number">
                                    <b-input type="text" v-model="cc.number" :state="errors['cc.number'] ? false: null" aria-describedby="input-live-feedback" />
                                    <!-- This will only be shown if the preceding input has an invalid state -->
                                    <b-form-invalid-feedback id="input-live-feedback">
                                        {{errors['cc.number']}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col sm="8">
                                
                                <b-form-group label="Expiration" :state="errors['cc.expMM'] || errors['cc.expYY'] ? false : null" :invalid-feedback="errors['cc.expMM']">
                                    <b-row>
                                        <b-col md="6">
                                            <multiselect 
                                                v-model="cc.expMM" 
                                                :allowEmpty="false" 
                                                :options="expMonths" 
                                                placeholder="MM" 
                                                selectLabel=""
                                                selectedLabel=""
                                                deselectLabel=""
                                                >
                                            </multiselect>
                                        </b-col>
                                        <b-col md="6">
                                            <multiselect 
                                                v-model="cc.expYY" 
                                                :allowEmpty="false" 
                                                :options="expYears" 
                                                placeholder="YY" 
                                                selectLabel=""
                                                selectedLabel=""
                                                deselectLabel=""
                                                >
                                            </multiselect>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label="CVV">
                                    <b-input type="text" v-model="cc.cvv" :state="(errors['cc.cvv']) ? false : null" />
                                    <b-form-invalid-feedback id="input-live-feedback">
                                        {{errors['cc.cvv']}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-checkbox id="save" class="float-left" v-if="false"
                                    v-model="saveLater">
                                    Save for later use
                                </b-form-checkbox>
                                <b-button class="green float-right" type="submit" :disabled="submitting"><font-awesome-icon v-if="submitting" icon="spinner" pulse />  Complete Order</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    import CountrySelect from '../CountrySelect'
    import StateSelect from '../StateSelect'
    import Multiselect from 'vue-multiselect'
    export default {
        components: {CountrySelect, StateSelect, Multiselect},
        data() {
            return {
                project_id: null,
                project: null,
                name: '',
                session_key: '',
                couponCode: '',
                billing: {
                    first_name: '',
                    last_name: '',
                    street_1: '',
                    street_2: '',
                    city: '',
                    state: '',
                    postal_code: '',
                    country: 'US',
                    phone: ''
                },
                cc: {
                    name: '',
                    number: '',
                    expMM: null,
                    expYY: null,
                    cvv: ''
                },
                coupon: {
                    code: null,
                    type: null,
                    amount: 0,
                    percent: 0
                },
                saveLater: false,
                submitting: false,

                errors: {}
            };
        },
        methods: {
           applyCoupon () {
               this.errors = {}

               this.axios.post('/projects/' + this.project.uuid + '/checkout/coupon', {coupon_code: this.couponCode})
                .then(res => {
                    if (typeof res.data.type !== 'undefined') {
                        this.coupon.type = res.data.type
                        this.coupon.amount = parseFloat(res.data.amount).toFixed(2)
                        if (res.data.type === 'percent') {      
                            this.coupon.percent = parseFloat(res.data.percent)
                            this.coupon.amount = (this.subtotal * parseFloat(res.data.percent)).toFixed(2)
                        }
                        this.coupon.code = res.data.coupon_code
                    }
                })
                .catch(err => {
                    if (err.response.data) {
                        this.$set(this.errors, 'coupon_code', err.response.data.message)
                    }
                })
           },
           submitOrder () {
               this.errors = {}
               this.submitting = true;

                let data = {
                    billing: this.billing,
                    coupon: this.coupon,
                    cc: this.cc,
                    id: this.project_id
                }

                if (data.cc.name === '')
                    data.cc.name = this.ccName

                this.$store.dispatch('project/submit', {data})
                    .then((order) => {
                        this.$store.commit('project/removeCurrent')
                        this.$store.commit('prompt/clear')
                        this.$router.push({name: 'OrderComplete', params: { id: order.uuid }});
                    })
                    .catch(err => {
                        this.submitting = false;
                        if (err.response.data) {
                            this.errors = err.response.data.errors
                            for (var field in err.response.data.errors) {
                                this.errors[field] = err.response.data.errors[field][0]

                                if (field === 'credit_card') {
                                    this.errors[field] = this.errors[field] + '<br />\n' + err.response.data.message
                                }
                            }
                        }
                    })
           },
           updateCCName (val) {
               this.cc.name = val
           },
           checkField (fieldName) {
               if (typeof this.errors[fieldName] === 'undefined') {
                   return null
               }
           }
        },
        computed: {
           extra_words_fee() {
               var extra_words_fee = 0;
               for(var i = 0; i < this.project.prompts.length; i++) {
                   extra_words_fee += parseFloat(this.project.prompts[i].extra_words_fee);
               }

               return extra_words_fee.toFixed(2);
           },
           subtotal() {
               var subtotal = 0;
               for(var i = 0; i < this.project.prompts.length; i++) {
                   subtotal += parseFloat(this.project.prompts[i].amount);
               }

               return (subtotal + parseFloat(this.project.record_fee)).toFixed(2);
           },
           total_amount() {
               if (this.coupon.code) {
                   return (this.subtotal - this.coupon.amount).toFixed(2)
               }
               return this.subtotal;
           },
           ccName () {
               if (this.cc.name === '') {
                   return this.billing.first_name + ' ' + this.billing.last_name
               }

               return this.cc.name
           },
           expMonths () {
               let months = []
               for (var i = 1; i < 13; i++) {
                   let val = (i < 10) ? '0' + i : i.toString()
                   months.push(val)
               }
               return months
           },
           expYears () {
               let years = []
               let now = new Date()
               let year = now.getFullYear()
               year = year - 1
               for (var i = 1; i < 7; i++) {
                   let val = (i + year).toString()
                   years.push(val.substr(2))
               }
               return years
           }
        },
        created() {
            if( typeof( this.$route.params.id ) !== 'undefined' ) {
                 this.project_id = this.$route.params.id;
            }

            this.$store.dispatch('project/read', this.project_id)
                .then(project => {
                    this.project = project

                    if(project.status === 'paid' && project.order) {
                        this.$router.push({name: 'OrderHistory'});
                    }
                })

            if (this.user) {
                this.billing.first_name = this.user.first_name
                this.billing.last_name = this.user.last_name
            }

            if (this.user && this.user.primary_address) {
                this.billing.street_1 = this.user.primary_address.street_1
                this.billing.street_2 = this.user.primary_address.street_2
                this.billing.city = this.user.primary_address.city
                this.billing.state = this.user.primary_address.state
                this.billing.country = this.user.primary_address.country
                this.billing.postal_code = this.user.primary_address.postal_code
                this.billing.phone = this.user.primary_address.phone
            }
        }
    };
</script>


// WEBPACK FOOTER //
// prompts/components/checkout/Checkout.vue